import { toast } from "react-toastify";
// import i18n from "../i18n";

export const handleApiError = (e) => {
  // console.log("API Error:", e?.response?.error);
  const errorData = e.response?.data?.error;
  if (!errorData) {
    toast.error(e.message || "Unknown error");
    return;
  }
  // console.log("API Error:", errorData);
  // const currentLang = i18n.language || "ar";

  // if (currentLang === "ar" && errorData.message) {
  if (errorData.message_AR) {
    toast.error(errorData.message_AR);
  }
};
